import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useTheme } from 'foundations-theming/utils';
import { isHubSpotNativeApp } from '../../../utils/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import NavbarMobileTabs from './NavbarMobileTabs';
import NavbarTabs from './NavbarTabs';
import AcademyToSoftware from '../../../containers/AcademyToSoftware/AcademyToSoftware';
import { DevtoolsButton } from '../../devtools';
import CopilotNavLaunchButton from '../../copilot/components/CopilotNavLaunchButton';
import { FaceNav } from '../../../components/FaceNav/FaceNav';
import NavSeparator from './NavSeparator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Navbar = () => {
  const {
    isMobileNavbar
  } = useMediaQuery();
  const theme = useTheme();
  const isMobileApp = window.navigator.userAgent.indexOf('HubSpotiOS') > -1 || window.navigator.userAgent.indexOf('HubSpotAndroid') > -1;
  return /*#__PURE__*/_jsxs(Flex, {
    backgroundColor: "do-not-use-pantera",
    blockSize: isMobileApp ? '44px' : undefined,
    id: "academy-nav",
    insetBlockStart: "0",
    justifyContent: "space-between",
    position: "sticky",
    zIndex: 5,
    children: [isMobileNavbar ? /*#__PURE__*/_jsx(NavbarMobileTabs, {}) : /*#__PURE__*/_jsx(NavbarTabs, {}), !isHubSpotNativeApp &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("div", {
      className: "vr-hidden",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        blockSize: theme.space['1100'],
        inlineSize: "max-content",
        justifyContent: "end",
        maxInlineSize: "fit-content",
        children: [/*#__PURE__*/_jsx(AcademyToSoftware, {}), !isMobileNavbar && /*#__PURE__*/_jsx(CopilotNavLaunchButton, {}), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          inlineSize: "max-content",
          children: [/*#__PURE__*/_jsx(View, {
            inlineSize: theme.space['250']
          }), /*#__PURE__*/_jsx(DevtoolsButton, {}), /*#__PURE__*/_jsx(NavSeparator, {}), /*#__PURE__*/_jsx(FaceNav, {})]
        })]
      })
    })]
  });
};